import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('en'); // 'en' for English, 'pt' for Portuguese

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'pt' : 'en');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100">
      <Header language={language} onToggleLanguage={toggleLanguage} />
      <Hero language={language} />
      <Features language={language} />
      <HowItWorks language={language} />
      <Benefits language={language} />
      <CTA language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;

